<template>
	<div v-if="isShowing" v-click-outside="close" class="language-container">
		<div class="flex pointer" @click="show">
			<div>
				<img :src="langSrc" alt="lang" width="23" height="23">
			</div>
			<div class="language-title medium-sm-text ml-10" :class="isPlansPage || isEventsPage ? 'text-white' : 'text-black'">
				{{ checked }}
			</div>
			<div>
				<img class="ml-5" :src="arrowSrc" alt="arrow" width="10" height="5">
			</div>
		</div>
		<div class="language-wrap">
			<transition name="fade">
				<div v-if="showDropdown" class="language-drawer" :class="{ 'active': activeMenu, 'events-view': isEventsPage }">
					<div class="flex items-center">
						<div class="language-subtitle medium-sm-text">
							{{ $tc('common.languageSelectorText') }}
						</div>
						<div>
							<button class="close-btn" @click="show" />
						</div>
					</div>
					<div class="drawer-list">
						<div v-for="language in $i18n.locales" :key="language.code" class="drawer-list-item">
							<div class="drawer-list-name">
								<input :id="language.code" v-model="checked" :value="language.name" type="radio" @change="chooseLanguage">
								<label :for="language.code">{{ language.name }}</label>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	name: 'LanguageSelector',
	props: {
		activeMenu: {
			type: Boolean,
			required: ''
		}
	},
	data () {
		return {
			showDropdown: false
		}
	},
	computed: {
		checked: {
			get () {
				return this.$i18n.localeProperties.name
			},
			set (newValue) {
				this.$i18n.localeProperties.name = newValue
			}
		},
		isPlansPage () {
			return this.$route.name === 'plans' || this.$route.name === 'campaign-thanksgiving'
		},
		isEventsPage () {
			return !!this.$route.name?.match(/events/) || !!this.$route.name?.match(/auth-index/)
		},
		langSrc () {
			return this.isPlansPage || this.isEventsPage
				? require('~/assets/icons/lang.svg')
				: require('~/assets/icons/lang-black.svg')
		},
		arrowSrc () {
			return this.isPlansPage || this.isEventsPage
				? require('~/assets/icons/ic-notification-arrow.svg')
				: require('~/assets/icons/ic-notification-arrow-black.svg')
		},
		isShowing () {
			return this.$i18n.locales.length > 1
		}
	},
	methods: {
		...mapActions({
			setLanguage: 'user/setLanguage'
		}),

		show () {
			if (this.$i18n.locales.length > 1) {
				this.showDropdown = !this.showDropdown
			}
		},

		close () {
			this.showDropdown = false
		},

		chooseLanguage (event) {
			const newLang = event.target.id
			const currentLang = this.$i18n.localeProperties.code
			const onError = (error) => {
				this.$toast.error(this.$tc('errors.networkError'))
				this.$bugsnag.notify(error)
			}

			if (newLang && newLang === currentLang) {
				return
			} else if (this.$nuxt.isOffline) {
				this.$toast.error(this.$tc('errors.networkError'))
				return
			}

			try {
				this.setLanguage(event.target.id)
			} catch (e) {
				onError(e)
			}
		}
	}
}
</script>

<style lang="scss">
.language-container {
	position: relative;
	@include respond-below(phone) {
		margin-left: 10px;
	}

	.language-title {
		@include respond-below(phone) {
			display: none;
		}
	}

	.language-drawer {
		top: 40px;
		right: 0;
		min-width: 277px;
		position: absolute;
		border-radius: 11px;
		backdrop-filter: blur(10px);
		padding: 19px 19px 19px 23px;
		background-color: rgba(244, 244, 244, 0.85);

		@-moz-document url-prefix() {
			background-color: rgba(244, 244, 244, 1);
		}
		box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.33);
		z-index: 100;
		&.active {
			@include respond-below(laptop) {
				right: -110px;
				top: -270px;
			}
		}

		.language-subtitle {
			color: rgba(0, 0, 0, 0.7);
		}

		&.events-view {
			min-width: 260px;

			.language-subtitle {
				font-size: 12px;
			}
		}

		.close-btn {
			width: 20px;
			height: 20px;
			cursor: pointer;
			margin-left: 5px;
			object-fit: contain;
			padding: 3px 4px 4px 3px;
			background-repeat: no-repeat;
			background-image: url('../../assets/icons/close.svg');
		}

		.drawer-list-item {
			color: black;
			margin: 20px 0;

			.drawer-list-name {
				display: flex;
				align-items: center;

				input[type="radio"] {
					margin: 0;
					cursor: pointer;
					visibility: hidden;
					-moz-appearance: initial;
					&:after {
						top: -2px;
						@-moz-document url-prefix() {
							top: 3px;
						}
						left: -1px;
						content: '';
						width: 16px;
						height: 16px;
						position: relative;
						visibility: visible;
						border-radius: 15px;
						display: inline-block;
						border: 1.5px solid #9e9e9e;
					}
					&:hover:after {
						box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.33);
					}
					&:checked:after {
						content: '';
						width: 16px;
						height: 16px;
						position: relative;
						visibility: visible;
						background-size: 100%;
						display: inline-block;
						border: 0 solid transparent;
						background-repeat: no-repeat;
						background-image: url('../../assets/icons/check-circle.svg');
					}
					&:checked + label {
						color: #009BC9;
					}
				}

				label {
					margin-left: 15px;
					&:hover {
						transition: 0.4s;
						opacity: 0.5;
					}
				}
			}
		}
	}
}
</style>
